{
  "familyId": "TOPO-NL-LANDSCHAP",
  "questions": [
    {
      "id": "TOPO-NL-LANDSCHAP-001",
      "familyId": "TOPO-NL-LANDSCHAP",
      "module": "Topo",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "nederland",
      "subSkill": "topo_landschap_nl",
      "questionType": "multiple_choice",
      "question": "Welk landschapstype vind je vooral in Drenthe en Overijssel?",
      "options": [
        "Zandlandschap",
        "Zeekleilandschap",
        "Rivierenlandschap",
        "Duinlandschap"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_landschap_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Landschappen van Nederland",
            "content": "Nederland heeft vier hoofdlandschappen: zandlandschap (oost/midden), zeekleilandschap (noord/zuidwest), rivierenlandschap (midden, langs grote rivieren) en duinlandschap (kust). Drenthe en Overijssel liggen in het oosten → zandlandschap.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "landschap_zand",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Drenthe en Overijssel liggen in het oosten van Nederland. Daar vind je het zandlandschap, gevormd door de ijstijden. Je herkent het aan heidevelden, bossen en zandverstuivingen.",
        "solutionSteps": [
          "Drenthe en Overijssel liggen in Oost-Nederland",
          "Oost-Nederland = zandlandschap (gevormd door ijstijden)",
          "Kenmerken: heide, bossen, zandverstuivingen"
        ],
        "distractorExplanations": {
          "0": "Goed! Drenthe en Overijssel liggen in het zandlandschap van Oost-Nederland.",
          "1": "Zeekleilandschap vind je in het noorden (Groningen, Friesland) en zuidwesten (Zeeland). Dat is land dat door de zee is aangespoeld. Drenthe en Overijssel liggen meer landinwaarts.",
          "2": "Rivierenlandschap vind je langs de grote rivieren (Rijn, Maas, Waal) in Gelderland en Zuid-Holland. Drenthe en Overijssel liggen daar niet.",
          "3": "Duinlandschap vind je alleen langs de kust (Noord-Holland, Zuid-Holland). Drenthe en Overijssel liggen in het binnenland."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-LANDSCHAP-001-OPT1",
            "optionIndex": 1,
            "label": "Dat is land dat door de zee is aangespoeld"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-LANDSCHAP-001-OPT2",
            "optionIndex": 2,
            "label": "Drenthe en Overijssel liggen daar niet"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-LANDSCHAP-001-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Duinlandschap"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-LANDSCHAP-002",
      "familyId": "TOPO-NL-LANDSCHAP",
      "module": "Topo",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "nederland",
      "subSkill": "topo_landschap_nl",
      "questionType": "multiple_choice",
      "question": "Wat is een kenmerk van het rivierenlandschap?",
      "options": [
        "Uiterwaarden die bij hoog water overstromen",
        "Hoge zandduinen langs de kust",
        "Uitgestrekte heidevelden",
        "Droogmakerijen onder zeeniveau"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_landschap_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Rivierenlandschap",
            "content": "Het rivierenlandschap ligt langs de grote rivieren (Rijn, Maas, Waal). Kenmerken: uiterwaarden, dijken, kleigrond, en regelmatige overstromingen. De uiterwaarden zijn de lage gebieden tussen de rivier en de dijk.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "landschap_rivier",
      "variantIndex": 2,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Uiterwaarden zijn de lage gebieden tussen de rivier en de dijk. Bij hoog water stromen ze onder. Dit is typisch voor het rivierenlandschap langs de Rijn, Maas en Waal.",
        "solutionSteps": [
          "Rivierenlandschap = langs grote rivieren (Rijn, Maas, Waal)",
          "Kenmerken: uiterwaarden, dijken, kleigrond",
          "Uiterwaarden overstromen bij hoog water"
        ],
        "distractorExplanations": {
          "0": "Goed! Uiterwaarden die overstromen zijn typisch voor het rivierenlandschap.",
          "1": "Zandduinen langs de kust horen bij het duinlandschap, niet het rivierenlandschap.",
          "2": "Heidevelden horen bij het zandlandschap in Oost-Nederland.",
          "3": "Droogmakerijen (polders) horen bij het zeekleilandschap in West-Nederland."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-LANDSCHAP-002-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Hoge zandduinen langs de kust"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-LANDSCHAP-002-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Uitgestrekte heidevelden"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-LANDSCHAP-002-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Droogmakerijen onder zeeniveau"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-LANDSCHAP-003",
      "familyId": "TOPO-NL-LANDSCHAP",
      "module": "Topo",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "nederland",
      "subSkill": "topo_landschap_nl",
      "questionType": "multiple_choice",
      "question": "Welke provincie heeft GEEN zeekleilandschap?",
      "options": [
        "Drenthe",
        "Groningen",
        "Friesland",
        "Zeeland"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_landschap_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Zeekleilandschap",
            "content": "Zeekleilandschap vind je waar de zee land heeft afgezet: Noord-Nederland (Groningen, Friesland) en Zuidwest-Nederland (Zeeland). Drenthe ligt landinwaarts en heeft zandlandschap.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "landschap_zeeklei_niet",
      "variantIndex": 3,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.7,
      "feedback": {
        "explanationText": "Drenthe ligt in het binnenland van Noord-Nederland en heeft zandlandschap (gevormd door ijstijden). Groningen, Friesland en Zeeland liggen aan de kust en hebben wél zeekleilandschap.",
        "solutionSteps": [
          "Zeekleilandschap = aan de kust (door zee afgezet)",
          "Groningen, Friesland, Zeeland = aan de kust → zeeklei ✓",
          "Drenthe = binnenland → zandlandschap, géén zeeklei"
        ],
        "distractorExplanations": {
          "0": "Goed! Drenthe ligt in het binnenland en heeft zandlandschap, geen zeekleilandschap.",
          "1": "Groningen ligt aan de Waddenzee en heeft wél zeekleilandschap in het noorden van de provincie.",
          "2": "Friesland ligt aan de Waddenzee en heeft wél zeekleilandschap.",
          "3": "Zeeland is omringd door zee en heeft uitgebreid zeekleilandschap."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-LANDSCHAP-003-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Groningen"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-LANDSCHAP-003-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Friesland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-LANDSCHAP-003-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Zeeland"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-LANDSCHAP-004",
      "familyId": "TOPO-NL-LANDSCHAP",
      "module": "Topo",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "nederland",
      "subSkill": "topo_landschap_nl",
      "questionType": "multiple_choice",
      "question": "Hoe zijn de Veluwe en de Utrechtse Heuvelrug ontstaan?",
      "options": [
        "Door ijstijden (stuwwallen)",
        "Door vulkaanuitbarstingen",
        "Door de zee (aangespoeld zand)",
        "Door rivieren (afgezet slib)"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_landschap_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stuwwallen",
            "content": "Tijdens de ijstijden schoof een enorme ijskap over Nederland. Het ijs duwde de grond omhoog: dat zijn stuwwallen. De Veluwe en Utrechtse Heuvelrug zijn bekende stuwwallen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "landschap_stuwwal",
      "variantIndex": 4,
      "citoDifficulty": 0.4,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "De Veluwe en Utrechtse Heuvelrug zijn stuwwallen: heuvels die ontstonden doordat gletsjers tijdens de ijstijden de grond omhoog duwden. Nederland heeft geen vulkanen, dus vulkaanuitbarstingen klopt niet.",
        "solutionSteps": [
          "Veluwe en Utrechtse Heuvelrug = stuwwallen",
          "Stuwwallen = grond omhooggeduwd door gletsjers (ijstijden)",
          "Nederland heeft geen vulkanen"
        ],
        "distractorExplanations": {
          "0": "Goed! De Veluwe en Utrechtse Heuvelrug zijn stuwwallen, gevormd door gletsjers tijdens de ijstijden.",
          "1": "Nederland heeft geen vulkanen. Vulkaanuitbarstingen komen voor in landen als IJsland of Italië.",
          "2": "De zee spoelt zand aan langs de kust (duinen), maar de Veluwe en Utrechtse Heuvelrug liggen in het binnenland.",
          "3": "Rivieren zetten slib af in het rivierenlandschap (uiterwaarden), maar stuwwallen zijn door ijs gevormd."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-LANDSCHAP-004-OPT1",
            "optionIndex": 1,
            "label": "Nederland heeft geen vulkanen"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-LANDSCHAP-004-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Door de zee (aangespoeld zand)"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-LANDSCHAP-004-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Door rivieren (afgezet slib)"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-LANDSCHAP-005",
      "familyId": "TOPO-NL-LANDSCHAP",
      "module": "Topo",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "nederland",
      "subSkill": "topo_landschap_nl",
      "questionType": "matching",
      "question": "Koppel elk landschapstype aan het juiste kenmerk.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          {
            "left": "Zandlandschap",
            "right": "Heidevelden en bossen"
          },
          {
            "left": "Zeekleilandschap",
            "right": "Polders en dijken"
          },
          {
            "left": "Rivierenlandschap",
            "right": "Uiterwaarden"
          },
          {
            "left": "Duinlandschap",
            "right": "Zandheuvels langs de kust"
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_landschap_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kenmerken per landschap",
            "content": "Zand = heide, bossen (oost). Zeeklei = polders, dijken (kust). Rivier = uiterwaarden (langs rivieren). Duin = zandheuvels (kust).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "landschap_kenmerken_match",
      "variantIndex": 5,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "Elk landschap heeft eigen kenmerken: zand → heide/bossen, zeeklei → polders/dijken, rivier → uiterwaarden, duin → zandheuvels aan de kust.",
        "solutionSteps": [
          "Zandlandschap → heidevelden en bossen (Oost-Nederland)",
          "Zeekleilandschap → polders en dijken (kust)",
          "Rivierenlandschap → uiterwaarden (langs rivieren)",
          "Duinlandschap → zandheuvels langs de kust"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      }
    },
    {
      "id": "TOPO-NL-LANDSCHAP-006",
      "familyId": "TOPO-NL-LANDSCHAP",
      "module": "Topo",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "nederland",
      "subSkill": "topo_landschap_nl",
      "questionType": "multiple_choice",
      "question": "Op de grens van Noord-Brabant en Limburg ligt een groot natuurgebied dat vroeger een veengebied was. Hoe heet dit gebied?",
      "options": [
        "De Peel",
        "De Veluwe",
        "De Biesbosch",
        "Het Groene Hart"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_landschap_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De Peel",
            "content": "De Peel is een natuurgebied op de grens van Noord-Brabant en Limburg. Het was vroeger een groot hoogveengebied. Veel veen is afgegraven (turf), maar delen zijn nu beschermd natuurgebied (De Groote Peel).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "de_peel_veengebied",
      "variantIndex": 6,
      "citoDifficulty": 0.4,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "De Peel is een natuurgebied op de grens van Noord-Brabant en Limburg. Het was vroeger een uitgestrekt hoogveengebied. Eeuwenlang werd hier turf gestoken (veen afgegraven als brandstof). Tegenwoordig is De Groote Peel een beschermd nationaal park met zeldzame planten en dieren.",
        "solutionSteps": [
          "Welk natuurgebied ligt op de grens van Brabant en Limburg?",
          "De Peel was een groot hoogveengebied",
          "Vroeger werd hier turf gestoken (veen als brandstof)",
          "Nu is De Groote Peel een beschermd nationaal park"
        ],
        "distractorExplanations": {
          "0": "Goed! De Peel is het voormalige veengebied op de grens van Noord-Brabant en Limburg.",
          "1": "De Veluwe is een groot natuurgebied in Gelderland (zandlandschap met bossen en heide), niet op de grens van Brabant en Limburg.",
          "2": "De Biesbosch ligt in het noordwesten van Noord-Brabant, bij de rivieren. Het is een zoetwatergetijdengebied, geen veengebied. De Peel ligt op de grens met Limburg.",
          "3": "Het Groene Hart is het open gebied midden in de Randstad (tussen Amsterdam, Rotterdam, Den Haag en Utrecht). Het ligt niet in het zuiden van Nederland."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-LANDSCHAP-006-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: De Veluwe"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-LANDSCHAP-006-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: De Biesbosch"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-LANDSCHAP-006-OPT3",
            "optionIndex": 3,
            "label": "Het ligt niet in het zuiden van Nederland"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-LANDSCHAP-007",
      "familyId": "TOPO-NL-LANDSCHAP",
      "module": "Topo",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "nederland",
      "subSkill": "topo_landschap_nl",
      "questionType": "multiple_choice",
      "question": "In het noordwesten van Noord-Brabant ligt een bijzonder natuurgebied met eilandjes, kreken en getijden. Hoe heet dit gebied?",
      "options": [
        "De Biesbosch",
        "De Peel",
        "De Veluwe",
        "De Waddenzee"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_landschap_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De Biesbosch",
            "content": "De Biesbosch is een zoetwatergetijdengebied in het noordwesten van Noord-Brabant, waar de Maas en de Waal samenkomen. Het is een van de weinige zoetwatergetijdengebieden in Europa, met eilandjes, kreken en veel vogels.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "de_biesbosch",
      "variantIndex": 7,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "De Biesbosch is een uniek zoetwatergetijdengebied in het noordwesten van Noord-Brabant. Het ligt waar de Maas en de Waal samenkomen. Het gebied ontstond na de Sint-Elisabethsvloed (1421) en bestaat uit eilandjes, kreken en rietlanden. Het is een van de laatste zoetwatergetijdengebieden van Europa.",
        "solutionSteps": [
          "Welk natuurgebied ligt in het noordwesten van Noord-Brabant?",
          "De Biesbosch ligt waar de Maas en Waal samenkomen",
          "Het is een zoetwatergetijdengebied (zoet water + getijden)",
          "Kenmerken: eilandjes, kreken, rietlanden, veel vogels"
        ],
        "distractorExplanations": {
          "0": "Goed! De Biesbosch is het zoetwatergetijdengebied in het noordwesten van Noord-Brabant.",
          "1": "De Peel ligt op de grens van Noord-Brabant en Limburg en is een voormalig veengebied. Het heeft geen eilandjes of getijden.",
          "2": "De Veluwe ligt in Gelderland en is een zandlandschap met bossen en heide. Het ligt niet in Noord-Brabant en heeft geen getijden.",
          "3": "De Waddenzee ligt in het noorden van Nederland en heeft zout water. De Biesbosch heeft zoet water en ligt in het zuiden."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-LANDSCHAP-007-OPT1",
            "optionIndex": 1,
            "label": "Het heeft geen eilandjes of getijden"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-LANDSCHAP-007-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: De Veluwe"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-LANDSCHAP-007-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: De Waddenzee"
          }
        ]
      }
    }
  ]
}